import { memo, useState, type FC } from 'react';

import { FilterButton } from 'components/common/Table/actions';
import type { HeliosRecordDataTablesColumn } from 'types/dataHelios';
import { type useHeliosBrowseFilters } from 'utils/hooks/userAgendaTable/useHeliosBrowseFilters';

import { HeliosFilterDrawer } from './HeliosFilterDrawer';

interface HeliosBrowseFilterControlsProps {
  modalOpen: boolean;
  columns: HeliosRecordDataTablesColumn[];
  browseFilters: ReturnType<typeof useHeliosBrowseFilters>;
}

const HeliosBrowseFilterControlsBase: FC<HeliosBrowseFilterControlsProps> = ({ modalOpen, columns, browseFilters }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [prevModalOpen, setPrevModalOpen] = useState(modalOpen);

  if (modalOpen !== prevModalOpen) {
    setPrevModalOpen(modalOpen);

    if (!modalOpen) {
      setDrawerOpen(false);
    }
  }

  return (
    <>
      <FilterButton onClick={() => setDrawerOpen(true)} activeCount={browseFilters.activeFilters.length} disabled={columns.length === 0} />
      <HeliosFilterDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        columns={columns}
        activeFilters={browseFilters.activeFilters}
        onApplyFilters={browseFilters.handleApplyFilters}
        savedFilters={browseFilters.savedFilters}
        onSaveFilter={browseFilters.handleSaveFilter}
        onLoadFilter={browseFilters.handleLoadFilter}
        onDeleteFilter={browseFilters.handleDeleteSavedFilter}
        onUpdateFilter={browseFilters.handleUpdateFilter}
        onUnloadFilter={browseFilters.handleUnloadFilter}
        activeSavedFilterId={browseFilters.activeSavedFilterId}
        isSaving={browseFilters.isSavingOrUpdating}
        aboveModal
        allowDefaultFilter={false}
      />
    </>
  );
};

const HeliosBrowseFilterControls = memo(HeliosBrowseFilterControlsBase);

export { HeliosBrowseFilterControls };
